<template>
       <!-- :style="headColor" -->
  <div class="headbar"
       style="background:#4199cc"
       :class="collapse?'position-collapse-left':'position-left'">
    <div style="position:absolute;left:1rem">
      <i class="el-icon-s-operation operation"
         @click="handleOpen"></i>
    </div>
    <div :class="loginTissueId?'HeadBar_tools':'HeadBar_toolsTwo'">
      <!-- <div class="head_item"
           @click="Fullscreen?exitFullscreen():Big()">
        <span class="iconfont iconquanping"
              style="font-size:14px">全屏显示
        </span>
      </div> -->
      <div class="head_item"
           id="myTissue"
            v-if="loginTissueName"
           @click="dropdownMenuClick1">
        <span class="name">{{loginTissueName}}</span>
      </div>
      <div class="head_item"
           id="myPanel"
           @click="dropdownMenuClick">
        <!-- <img src="@/assets/images/profile.jpg"
             class="personalImg"> -->
        <span class="name">{{nickName}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HeadBar',
  computed: {
    ...mapState({
      collapse: state => state.app.collapse,
      headColor: state => state.app.headColor
    })
  },
  props: {},
  data () {
    return {
      isCollapse: false,
      nickName: (JSON.parse(localStorage.personal)).nickName,
      loginTissueName:localStorage.loginTissueName,
      Fullscreen: false,
      loginTissueId:localStorage.loginTissueId
    }
  },
  methods: {
    handleOpen () {
      this.$store.commit('onCollapse')
    },
    // 全屏
    Big () {
      this.Fullscreen = true
      document.documentElement.requestFullscreen()
    },
    exitFullscreen () {
      this.Fullscreen = false
      document.exitFullscreen()
    },
    dropdownMenuClick () {
      this.$store.commit('dropdownMenu', true)
    },
    dropdownMenuClick1 () {
      this.$store.commit('dropdownTissue', true)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/assets/style/mixins.styl'
.headbar
  position fixed
  top 0
  left 200px
  right 0
  height 50px
  line-height 50px
.head_item
  font-size 0.7rem
  font-weight 600
  color #fff
  cursor pointer
  // margin-left 20px
  line-height 50px
  height 50px
  // width 50%
.personalImg
  width 27px
  height 27px
  border-radius 27px
  margin-bottom 11.5px
.head_item:hover
  background #DCDCDC
  opacity 1
.position-left
  left 200px
.position-collapse-left
  left 60px
.operation
  color #fff
  cursor pointer
.name
  display inline-block
  // margin-left 10px
  width 150px
  ellipsis()
</style>



// WEBPACK FOOTER //
// src/views/HeadBar/HeadBar.vue